import classNames from 'classnames';

import { SPACE_SUBSCRIPTIONS, SUBSCRIPTION_PLAN_NAME } from '@/constants';
import { useSpaceAndPageIDFromRouter } from '@/data/space/hooks';
import { useGetPageQuery } from '@/store';
import { SUBSCRIPTION_PLAN } from '@/types';
import TokenContext from '@/utils/jwt/tokenContext';
import { Check } from '@styled-icons/boxicons-regular';
import { SPACE_ACTION } from '@typedream/data';
import { Text } from '@typedream/ui';
import { useCallback, useContext, useEffect, useState } from 'react';

function PublishedPages({
  showTitle,
  currentPageOnly,
}: {
  showTitle?: boolean;
  currentPageOnly: boolean;
}) {
  const [spaceID, pageID] = useSpaceAndPageIDFromRouter();
  const { data: page } = useGetPageQuery([spaceID, pageID]);
  const [isUpgradeRequired, setisUpgradeRequired] = useState(false);
  const [plan, setplan] = useState(SUBSCRIPTION_PLAN.FREE);
  const { subscriptionTokenHandler } = useContext(TokenContext);

  // Check Subscription for Publishing
  const checkSubscription = useCallback(async () => {
    const sub = await subscriptionTokenHandler.getSubscription(spaceID as string);
    if (!sub.isAllowed(SPACE_ACTION.PublishUnlimitedPages, SPACE_SUBSCRIPTIONS)) {
      setisUpgradeRequired(true);
    }
    setplan(sub?.getPlan(SPACE_SUBSCRIPTIONS));
  }, [spaceID, subscriptionTokenHandler]);

  useEffect(() => {
    if (spaceID) {
      checkSubscription();
    }
  }, [spaceID, checkSubscription]);

  return (
    <div className={classNames('flex flex-col gap-2 py-2 px-[18px] w-full')}>
      {showTitle && (
        <div className="with-text-color is-size-7">
          {isUpgradeRequired ? 'Publishing Current Page Only' : 'Publishing'}
        </div>
      )}

      {currentPageOnly ? (
        <div className="flex text-xs leading-5 font-medium px-3 py-2.5 bg-background dark:bg-background-secondary w-full rounded-lg shadow-xs">
          <Check size={18} className="with-accent-text-color mr-2" />
          {page?.name}
        </div>
      ) : (
        <div className="flex text-xs leading-5 font-medium px-3 py-2.5 bg-background dark:bg-background-secondary w-full rounded-lg shadow-xs">
          <Check size={18} className="with-accent-text-color mr-2" />
          All Pages
        </div>
      )}
      {isUpgradeRequired && (
        <Text size="2xs" variant="secondary">
          {`You're on the ${SUBSCRIPTION_PLAN_NAME[plan]} plan. Publishing ${page?.name} will unpublish your other pages.`}
        </Text>
      )}
    </div>
  );
}

PublishedPages.defaultProps = {
  showTitle: undefined,
};

export default PublishedPages;
